import React, { Component, useState } from 'react';
import { CookiesProvider } from 'react-cookie';
import FooterBar from '../../shared/components/Footer/FooterBar'
import './App.css';

class App extends Component {


  render() {
    const { children,fondo } = this.props
  
    return (
      <CookiesProvider>

        <div className = 'App' >
        <div className="page-container">
          <div className="content-wrap">
          {children}
            
          </div>
        </div>
        </div>
        <FooterBar />

      </CookiesProvider>
    );
  }
}

export default App;
